import React, { useContext, useState, useEffect, useRef } from 'react';
import {
    Table,
    Input,
    Button,
    Popconfirm,notification,
    Form, InputRef,Select,Row,Col,Tag,Tabs,List } from 'antd';
import { FormInstance } from 'antd/lib/form';
import {DownOutlined,DeleteOutlined,SearchOutlined,PlusOutlined,WarningOutlined,
    CheckCircleOutlined} from '@ant-design/icons';
import {AnalysisDelete} from '@/resource/IconComponentSets';
const {Option} = Select;
const { TabPane } = Tabs;
import IF from '@/components/IF';
import { getSoilPropertyMethods } from '@/util/Request';
import Item from 'antd/lib/list/Item';
import './index.less';
import { useDispatch } from 'react-redux';

const EditableContext = React.createContext<FormInstance<any> | null>(null);

let editOption:any[] = [];

interface Item {
  key: string;
  name: string;
  age: string;
  address: string;
}

interface EditableRowProps {
  index: number;
}

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: keyof Item;
  record: Item;
  saveKey:string;
  hasTag:boolean;
  handleSave: (record: Item,items:any,isEstimationClick?:number) => void;
  option1?:any[];
  option2?:any[];
  option3?:any[];
  disabled:boolean
}

const EditableCell: React.FC<EditableCellProps> = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    saveKey,
    hasTag,
    option1,
    option2,
    option3,
    disabled=false,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const [open,setOpen] = useState(false);
    const inputRef = useRef<InputRef>(null);
    const form = useContext(EditableContext)!;
    const searchRef = useRef(null);
    const [keyUpSearch,setKeyUpSearch] = useState<string>('');

    const [text,setText] = useState('' as string);

    const dispatch = useDispatch();
    useEffect(() => {
        if (editing) {
            // inputRef.current!.focus();
            setOpen(false);
            searchRef.current!.focus();
        }
    }, [editing]);
    useEffect(() => {
        if(text==''){
            // console.log('zhixing');
            if(saveKey=='name'){
                console.log(record);
                setText(record['nameType']);
                if(record['nameType'] == 'TYPE') setEditing(true);
            }
            if(saveKey=='address'){
                // console.log(record);
                setText(record['addressType']);
                // if(record['addressType'] == '') setEditing(true);
            }
            if(saveKey=='age'){
                // console.log(record);
                setText(record[saveKey]);
                if(record[saveKey] == ' ') setEditing(true);
            }
        }
    }, [record]);

    const toggleEdit = (isEstimationClick?:boolean) => {
        console.log('lanxue fff toggleEdit saveKey',saveKey);
        console.log('lanxue fff toggleEdit record',record);
        console.log('lanxue fff toggleEdit editOption',editOption);
        if(!disabled) setEditing(!editing);
        form.setFieldsValue({ [saveKey]: record[saveKey] });
        if(isEstimationClick){
            console.log('lanxue fff toggleEdit isEstimationClick',isEstimationClick);
            if(record?.name
                && record?.name != 'Select Soil Properties'
                 && record?.name != 'select a property'
            ){
                let tmpPropertyId = null;
                editOption?.forEach((item)=>{
                    if(item?.name === record?.name) {
                        console.log('lanxue fff item?.name:record?.name',item?.name,record?.name);
                        tmpPropertyId = item?.id;
                    }
                });
                handleSave(null,null,tmpPropertyId);
                console.log('lanxue fff toggleEdit tmpPropertyId',tmpPropertyId);
            }
        }
    };

    const save = async (item,e,num) => {
        // console.log(e.target.innerHTML);
        console.log('lanxue 11111111111111111111111111111:===', item);
        console.log('lanxue 22222222222222222222222222222:===', e);
        console.log('lanxue 33333333333333333333333333333:===', num);
        console.log('lanxue option1 used for pyhisical',option1);
        console.log('lanxue option1 used for chemical',option2);
        try {
            if(e.target.id == 'openToSetCellValue'||e.target.id == 'names'){
                console.log('search');
            }else{
                setText(num=='1'?'CHEMICAL':'PHYSICAL');
                console.log('lanxue saveKey:===', saveKey);
                form.setFieldsValue({ [saveKey]: e.target.outerText });
                const values = await form.validateFields();
                console.log('lanxue record',record);
                console.log('lanxue values',values);
                console.log('lanxue items',items);
                const methodID = {methodID:'',unitCode:'',address:''};
                handleSave({ ...record, ...values,...methodID },item);
                toggleEdit();
            }

        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    const saves = async (e,num) => {
        // try {
        if(e.target.id == 'openToSetCellValue'||e.target.id == 'names'){
            console.log('search');
        }else{
            let val = e.target.value;
            if(num == 2){
                if(val == ''){
                    val = ' ';
                }
            }
            setText(val);
            form.setFieldsValue({ [saveKey]: val });
            const values = await form.validateFields();
            console.log(record,values);
            handleSave({ ...record, ...values },null);
            if(num==2){
                toggleEdit();
            }
        }

        // } catch (errInfo) {
        //     console.log('Save failed:', errInfo);
        // }
    };
    const handleChange = async (param)=>{
        const paramArray = param?.split('#');
        form.setFieldsValue({ [saveKey]: paramArray[0] });
        // console.log(param);
        const values = await form.validateFields();
        const ex = option3.find(e=>e.methodName == values[saveKey] && e.unitName == paramArray[1]);
        // return;
        const methodID = {methodID:ex.propertyMeasurementID,unitCode:ex.unitName};
        console.log(ex.unitName);
        setText(ex.unitName);
        handleSave({ ...record, ...values,...methodID },null);
        toggleEdit();
        setText(ex.unitName);
    };
    const onChange = (key: string) => {
        console.log('lanxue input table onChange',key);
        console.log('lanxue input table items',items);
    };
    let childNode = children;

    const searchKeyDown = (e)=>{
        console.log(e.target.value);
        setKeyUpSearch(e.target.value);
        // setText(e==1?'Chemical':'Physical');
    };

    const items = [
        {
            label: 'Chemical',
            key: '1',
            children: (
                <List
                    dataSource={option2}
                    renderItem={item => {
                        const iss = item.name.toLowerCase().indexOf(keyUpSearch.toLowerCase())>=0;
                        return (
                            iss&&<List.Item onClick={e=>{
                                console.log('lanxue Chemical click');
                                save(item,e,1);
                            }}>
                                {item.name}
                            </List.Item>
                        );
                    }}
                    style={{cursor:'pointer'}}
                />
            ),
            style: {height:200,overflow:'auto'}
        },
        {
            label: 'Physical',
            key: '2',
            children: (
                <List
                    dataSource={option1}
                    renderItem={item => {
                        const iss = item.name.toLowerCase().indexOf(keyUpSearch.toLowerCase())>=0;
                        return (
                            iss&&<List.Item onClick={e=>{
                                console.log('lanxue physical click');
                                save(item,e,2);
                            }}>
                                {item.name}
                            </List.Item>
                        );
                    }}
                    style={{cursor:'pointer'}}
                />
            ),
            style: {height:200,overflow:'auto'}
        }
    ];



    if (editable) {
        const childrens: React.ReactNode[] = [];
        option3!=undefined&&option3.map(obj=>{
            // console.log(obj.id,obj);
            childrens.push(<Option key={obj.propertyMeasurementID}
                value={`${obj.methodName}#${obj.unitName}`}
            >{obj.methodName}</Option>);
        });

        console.log('lanxue EditableCell saveKey',saveKey);
        console.log('lanxue EditableCell children',children);
        console.log('lanxue EditableCell childrens',childrens);
        console.log('lanxue EditableCell record',record);
        console.log('lanxue EditableCell option1',option1);
        console.log('lanxue EditableCell option2',option2);
        console.log('lanxue EditableCell option3',option3);
        console.log('lanxue EditableCell editOption ',editOption);
        childNode = editing ? (
            <Form.Item
                style={{ margin: 0 }}
                name={saveKey}
            >
                {/* <Input ref={inputRef} onPressEnter={save} onBlur={save} /> */}
                <IF show={option1==undefined&&option3!=undefined}>
                    <Select
                        ref={searchRef}
                        onBlur={e=>{toggleEdit();}}
                        placeholder="Please select"
                        onSelect={handleChange}
                        style={{ width: '250px'}}
                        dropdownMatchSelectWidth={false}
                        defaultValue={record[saveKey]}
                    >
                        {childrens}
                    </Select>
                </IF>
                <IF show={option1==undefined&&option3==undefined}>
                    <Input style={{background:'#F3F4F6'}} defaultValue={record[saveKey]} ref={searchRef} onPressEnter={e=>saves(e,1)} onBlur={e=>saves(e,2)}/>
                </IF>
                <IF show={option3==undefined&&option1!=undefined}>
                    <div style={{display:'flex',alignItems:'center'}}>
                        <span style={{
                            background: (()=>{
                                if(text==undefined) return '#F3F4F6';
                                if(text.toUpperCase()=='PHYSICAL'){
                                    return '#C6E6FF';
                                }
                                if(text.toUpperCase()=='CHEMICAL'){
                                    return '#E7DDFC';
                                }
                                if(text.toUpperCase()=='TYPE'){
                                    return '#F3F4F6';
                                }
                            })(),
                            color: (()=>{
                                if(text==undefined) return '#696F88';
                                if(text.toUpperCase()=='PHYSICAL'){
                                    return '#005693';
                                }
                                if(text.toUpperCase()=='CHEMICAL'){
                                    return '#643AAA';
                                }
                                if(text.toUpperCase()=='TYPE'){
                                    return '#696F88';
                                }
                            })(),
                            padding:'3px 5px',borderRadius:'3px',margin:'0 10px',fontSize:'12px',fontWeight:600,lineHeight:'16px'}}>
                            {text.toUpperCase()}
                        </span>
                        <Select
                            ref={searchRef}
                            placeholder="select a property"
                            defaultValue={record[saveKey]}
                            dropdownMatchSelectWidth={false}
                            style={{background:'#F3F4F6!important',width:'350px'}}
                            // onBlur={e=>save(e)}
                            // open={open}
                            // onBlur={e=>{toggleEdit();}}
                            onMouseDown={e => {
                                e.preventDefault();
                                console.log('lanxue dddddd');
                                console.log((e.target as HTMLElement).className);
                                if((e.target as HTMLElement).className=='ant-select-selection-search-input'||(e.target as HTMLElement).className=='ant-select-selection-item'){
                                    setOpen(!open);
                                    open&&toggleEdit();
                                }else{
                                    setOpen(true);
                                }
                            }}
                            notFoundContent={
                                <>
                                    <Input
                                        id='openToSetCellValue'
                                        placeholder="Search property"
                                        onMouseDown={
                                            e=>setOpen(true)}
                                        prefix={<SearchOutlined />}
                                        allowClear onKeyUp={e=>searchKeyDown(e)}/>
                                    <Tabs defaultActiveKey="1" onChange={onChange} items={items} />

                                </>
                            }
                        >
                            {/* {options} */}
                        </Select>
                    </div>
                </IF>
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{display:'flex',alignItems:'center'}}
                onClick={()=>{
                    toggleEdit(option1==undefined&&option3!=undefined);
                }}>
                <IF show={option3==undefined&&option1!=undefined}>
                    {/* <span style={{background: text=='Physical'?'#C6E6FF':'#E7DDFC',color: text=='Physical'?'#005693':'#643AAA',padding:'1px 5px',borderRadius:'3px',margin:'0 10px'}}>
                        {text.toUpperCase()}
                    </span> */}
                    <span style={{
                        background: (()=>{
                            if(text==undefined) return '#F3F4F6';
                            if(text.toUpperCase()=='PHYSICAL'){
                                return '#C6E6FF';
                            }
                            if(text.toUpperCase()=='CHEMICAL'){
                                return '#E7DDFC';
                            }
                            if(text.toUpperCase()=='TYPE'){
                                return '#F3F4F6';
                            }
                        })(),
                        color: (()=>{
                            if(text==undefined) return '#696F88';
                            if(text.toUpperCase()=='PHYSICAL'){
                                return '#005693';
                            }
                            if(text.toUpperCase()=='CHEMICAL'){
                                return '#643AAA';
                            }
                            if(text.toUpperCase()=='TYPE'){
                                return '#696F88';
                            }
                        })(),
                        padding:'3px 5px',borderRadius:'3px',margin:'0 10px',fontSize:'12px',fontWeight:600,lineHeight:'16px'}}>
                        {text.toUpperCase()}
                    </span>
                </IF>
                <IF show={option1==undefined&&option3==undefined}>
                    <span style={{padding:'0 20px',display:'block',minWidth:20,minHeight:20}}>{text}</span>
                </IF>
                <IF show={option3==undefined&&option1!=undefined}>
                    <div>
                        {record[saveKey]}
                    </div>
                </IF>
                <IF show={option1==undefined&&option3!=undefined}>
                    <a>
                        {record[saveKey]}
                        <DownOutlined style={{margin:'0 10px'}}/>
                    </a>
                </IF>
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

// type EditableTableProps = Parameters<typeof Table>[0];
interface EditableTableProps {
    Table:Parameters<typeof Table>[0];
    saveTable:(data:any)=>void
    editOption:any
    visible:boolean
    editParam:any
    disabled?:boolean
}

interface DataType {
    key: React.Key;
    name: string;
    age: string;
    address: string;
    unitCode:string;
    hasTag:boolean;
    methodID:string;
    nameType:string;
    addressType:string;
}

interface EditableTableState {
  dataSource: DataType[];
  count: number;
  opt1:any[];
  opt2:any[];
  option3:any[];
  sampleid:string;
}

// type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>;

class NextModel extends React.Component<EditableTableProps, EditableTableState> {
    columns: ({
        title: string;
        dataIndex: string;
        width: string;
        editable: boolean;
        render?: undefined;
    } |
    {
        title: string;
        dataIndex: string;
        width?: undefined;
        editable?: undefined;
        render?: undefined;
    } |
    {
        title: string;
        dataIndex: string;
        editable: boolean;
        width?: undefined;
        render?: undefined;
    } | {
        title: string;
        dataIndex: string;
        render: (_: any, record: { key: React.Key; }) =>
        JSX.Element; width?: undefined; editable?: undefined;
    })[];
    // columns: (ColumnTypes[number] & { editable?: boolean; dataIndex: string })[];

    constructor(props: EditableTableProps) {
        editOption = [...props.editOption];
        super(props);
        this.columns = [
            {
                title: 'Soil Properties',
                dataIndex: 'name',
                width: '50%',
                editable: true,
                // render: (text: string) => <a>{text}</a>
            },
            {
                width: '5%',
                title: 'Value',
                dataIndex: 'age',
                editable: true,
            },
            {
                width: '10%',
                title: 'Unit',
                dataIndex: 'unitCode',
                editable: true,
            },
            {
                title: 'Estimation Method',
                dataIndex: 'address',
                editable: true,
            },
            {
                title: ' ',
                dataIndex: 'operation',
                render: (_, record: { key: React.Key }) =>
                    this.state.dataSource.length >= 1 ? (
                        <Popconfirm
                            title="Sure to delete?"
                            okText="&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;"
                            onConfirm={() => this.handleDelete(record.key)}>
                            <div key='test-navi' className='default-table-height'><a style={{margin:'0 5px',color:'#CF3537',width:'10px'}}><AnalysisDelete /></a></div>
                        </Popconfirm>
                    ) : null,
            },
        ];
        const arr = [];
        if(props.editParam!=null||props.editParam!=undefined){
            const properTyValue = props.editParam.samples.propertyValues;
            properTyValue.map((obj,idx)=>{
                // console.log(obj);
                arr[idx] = {
                    key: idx,
                    name: obj.propertyName,
                    age: obj.propertyValue,
                    // address: obj.propMeasurementID,
                    address:obj.methodName,
                    hasTag:false,
                    // methodID:obj.propMeasurementID
                    methodID:obj.propMeasurementID,
                    nameType:obj.propertyClass,
                    addressType:obj.unitCode,
                    unitCode:obj.unitCode
                };
            });
        }else{
            console.log('add,add,add');
            arr[0] = {
                key: '0',
                unitCode:'',
                name: 'Select Soil Properties',
                age: ' ',
                address: 'Select Estimation Method',
                hasTag:false,
                methodID:'',
                nameType:'TYPE',
                addressType:'',
            };
        }
        console.log(props.editOption);
        this.state = {
            opt1:props.editOption.filter(e=>e.category=='Physical'),
            opt2:props.editOption.filter(e=>e.category=='Chemical'),
            dataSource: arr,
            sampleid:(props.editParam!=null)?props.editParam.sampleid:'',
            count: arr.length,
            option3:[]
        };
    }
    async componentDidMount(){
        const {props,state} = this;
        console.log(state);
        if(props.editParam!=null){
            const res = await getSoilPropertyMethods({
                // propertyName:'Thickness',
                // unit:'cm',
                // propertyID:items.id
            });
            console.log(res);
            this.setState({ option3: res });
            // const arr = [];
            // state.dataSource.map((obj,idx)=>{
            //     arr.push(Object.assign(obj,{methodID:res.find(e=>e.methodID==obj.methodID).})
            // })
            // console.log(this.state.dataSource);
            this.props.saveTable(this.state);
        }
    }
    componentDidUpdate(prevProps) {
        // console.log(prevProps, prevState, snapshot);
        // console.log(this.props.visible,prevProps.visible);
        if(prevProps.editParam!=null){
            console.log(111);
            if(prevProps.editParam.sampleid!=this.state.sampleid){
                const arr = [];
                const properTyValue = prevProps.editParam.samples.propertyValues;
                properTyValue.map((obj,idx)=>{
                    console.log(obj);
                    arr[idx] = {
                        key: idx,
                        name: obj.propertyName,
                        age: obj.propertyValue,
                        // address: obj.propMeasurementID,
                        address:obj.methodName,
                        hasTag:false,
                        // methodID:obj.propMeasurementID
                        methodID:obj.propMeasurementID,
                        nameType:obj.propertyClass,
                        addressType:obj.unitCode,
                        unitCode:obj.unitCode
                    };
                });
                this.setState({
                    sampleid:prevProps.editParam.sampleid,
                    dataSource: arr,
                });
            }
        }
        // console.log(this.props.editParam,this.props.visible,this.state.dataSource);
        if(this.props.editParam==null&&this.props.visible==false&&this.state.dataSource.length!=0){
            // console.log('shezhile');
            const arr = [];
            return this.setState({
                sampleid:'',
                dataSource: arr,
            });
        }

        // if(prevProps.editParam!=null&&this.state.sampleid!=''){
        //     this.setState({
        //         sampleid:'',
        //         dataSource: [],
        //     });
        // }
    }
    handleDelete = async (key: React.Key) => {
        const dataSource = [...this.state.dataSource];
        const datas = dataSource.filter(item => item.key !== key);
        await this.setState({ dataSource: datas});
        this.props.saveTable(this.state);
    };

    handleAdd = async () => {
        const { count, dataSource } = this.state;
        console.log('lanxue aa handleAdd this.state.dataSource',this.state.dataSource);
        let bar = true;
        this.state.dataSource.map(obj=>{
            if(obj.name == '' || obj.methodID == ''){
                bar = false;
            }
        });
        if(bar){
            const newData: DataType = {
                key: count,
                unitCode:'',
                name: 'Select Soil Properties',
                age: ' ',
                address: 'Select Estimation Method',
                hasTag:false,
                methodID:'',
                nameType:'TYPE',
                addressType:'',
            };
            await this.setState({
                dataSource: [...dataSource, newData],
                count: count + 1,
                option3: []
            });
            this.props.saveTable(this.state);
        }else{
            notification.open({
                duration: 3,
                message: 'Soil Properties and Estimation Method is required !',
                icon: <WarningOutlined style={{ color: '#E99921' }} />
            });
        }
    };
    getProperty = async (id)=>{
        const res = await getSoilPropertyMethods({
            // propertyName:'Thickness',
            // unit:'cm',
            propertyID:id
        });
        const childrens: React.ReactNode[] = [];
        res.map(obj=>{
            childrens.push(<Option key={obj.propertyMeasurementID} value={obj.propertyMeasurementID}>{obj.methodName}</Option>);
        });
    };
    handleSave = async (row: DataType,items,isEstimationClick?:number) => {
        if(isEstimationClick && isEstimationClick != 0){
            const res = await getSoilPropertyMethods({
                // propertyName:'Thickness',
                // unit:'cm',
                propertyID:isEstimationClick
            });
            console.log('lanxue aa res',res);
            this.setState({ option3: res });
            return;
        }
        console.log('lanxue aa row',row);
        console.log('lanxue aa items',items);
        const newData = [...this.state.dataSource];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        console.log(item,row,items);
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        console.log('lanxue aa save newData !!!',newData);
        await this.setState({ dataSource: newData });
        if(items!=null){
            const res = await getSoilPropertyMethods({
                // propertyName:'Thickness',
                // unit:'cm',
                propertyID:items.id
            });
            console.log('lanxue aa res',res);
            this.setState({ option3: res });
        }
        this.props.saveTable(this.state);
    };
    onFinish = (e)=>{
        console.log(e);
    };



    render() {
        const { dataSource } = this.state;
        console.log('lanxue aaa options3',this.state.option3);
        console.log('lanxue aaa this.props',this.props);
        const components = {
            body: {
                row: EditableRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: (record: DataType) => {
                    if(col.title == 'Soil Properties'){
                        return {
                            record,
                            editable: col.editable,
                            dataIndex: col.dataIndex,
                            title: col.title,
                            handleSave: this.handleSave,
                            saveKey:'name',
                            hasTag:true,
                            option1:this.state.opt1,
                            option2:this.state.opt2,
                            disabled:this.props.disabled
                        };
                    }
                    if(col.title == 'Estimation Method'){
                        console.log('lanxue aaaa record',record);
                        console.log('lanxue aaaa col',col);
                        return {
                            record,
                            editable: col.editable,
                            dataIndex: col.dataIndex,
                            title: col.title,
                            handleSave: this.handleSave,
                            // handleSave: ()=>{
                            //     this.handleSave();
                            // },
                            saveKey:'address',
                            hasTag:record.hasTag,
                            option3:this.state.option3,
                            disabled:this.props.disabled
                        };
                    }
                    if(col.title == 'Value'){
                        return {
                            record,
                            editable: col.editable,
                            dataIndex: col.dataIndex,
                            title: col.title,
                            handleSave: this.handleSave,
                            saveKey:'age',
                            hasTag:record.hasTag,
                            disabled:this.props.disabled
                        };
                    }
                },
            };
        });

        console.log('lanxue eee dataSource',dataSource);
        console.log('lanxue eee columns',columns);
        console.log('lanxue eee this.columns',this.columns);
        return (
            <div className='EditTableForStyle'>
                <Table
                    components={components}
                    rowClassName={() => 'editable-row'}
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                />
                <Button
                    onClick={this.handleAdd}
                    type="primary"
                    ghost shape="round" icon={<PlusOutlined />} style={{ margin:'10px 0' }}>
                    Soil Property
                </Button>
            </div>
        );
    }
}

export default NextModel;